/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type Period from '@linc-technologies/linced-common/models/timetable/period';

// Proto: timetable.Day.
export default class Day extends Fragment {
  declare [Type]: 'timetable/day';

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('number', { defaultValue: 0 })
  declare isoDayNumber: number;

  @array('string')
  declare periodIds: StatefulArray<string>;

  // periods gives the loaded period records in periodIds order. It does not
  // load periods. The structure query includes them, and the dates service
  // `warmPeriods` loads the missing periods before it shows a structure.
  // eslint-disable-next-line ember/require-computed-property-dependencies -- store is a service, not reactive state
  @computed('periodIds.[]')
  get periods(): Period[] {
    const periods: Period[] = [];
    for (const id of this.periodIds) {
      const period = this.store.peekRecord<Period>('timetable/period', id);
      if (period) {
        periods.push(period);
      }
    }
    return periods;
  }
}
